export default function Klikelementer() {
  return (
    <div className="container mt-20 mx-auto">
      <div>
        <h4 className="text-dxl md:text-d2xl font-bold text-doctio-green">
          Klikelementer
        </h4>

        <p>
          I denne video demonstreres, hvordan man skriver en frase med
          klikelementer. Efter oprettelse af frasen og udfyldning af titel,
          mappe og tags, som tidligere vist, er det nu tid til at skrive frasen.
          Basisbrugere kan skrive tekst, mens probrugere har adgang til de syv
          forskellige elementer.
        </p>

        <p>
          Fælles for alle elementerne er, at de indsættes ved at placere
          cursoren et sted i teksten og derefter klikke på det tilhørende ikon
          over området, hvor frasen skrives. De fleste elementer kan også
          flyttes ved at markere dem, kopiere dem og indsætte dem et andet sted.
        </p>

        <p>
          Det første element på menulinjen er en note, som bruges til at gemme
          noter eller hyppigt brugt information. Når noten er indsat, kan man
          klikke på ikonet, som åbner en boks med faner. Under hver fane kan man
          enten uploade en fil eller skrive noter.
        </p>

        <p>
          De andre elementer minder mere om hinanden. Man kan eksempelvis
          indsætte en tjekboks, hvor man kan skrive tekst, som enten kan være
          tilvalgt eller fravalgt. En talboks tillader kun skrivning af tal og
          kan være nyttig i forbindelse med logikker.
        </p>

        <p>
          Singlevalg og multivalg giver henholdsvis mulighed for at vælge ét
          eller flere af de forskellige valgmuligheder. Indenfor multivalg kan
          man også specificere, om valgene skal være positive eller negative.
        </p>

        <p>
          Vis/skjul funktionen på menulinjen fungerer som en toggle, der åbner
          og lukker. Dette kan være nyttigt, hvis man har flere planer til en
          frase, da man kan gemme meget tekst heri.
        </p>
        <p>
          Det er en god idé at opsætte frasen, så den er klar til brug. For
          eksempel kan man vælge at have bestemte elementer tilknyttet frasen
          som standard, så man ikke behøver at tilføje dem manuelt hver gang.
        </p>

        <p>
          Dette er en generel gennemgang af elementerne. Hvis man ønsker mere
          information om de specifikke elementer og hvordan logik tilknyttes til
          dem, er der også videoer om dette.
        </p>
      </div>

      <div className="mt-10">
        <iframe
          width="560"
          height="315"
          className="h-[200px] md:h-[600px]"
          style={{ width: "100%", borderRadius: "10px" }}
          src="https://www.youtube.com/embed/8200dOh7yoM?si=quO8vg6ctG84hjCo"
          title="YouTube video player"
          frameBorder={0}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen={true}
        ></iframe>
      </div>
    </div>
  );
}
